export default [
  {
    id: "active",
    name: "resources.bookmakers.status.active",
  },
  {
    id: "paused",
    name: "resources.bookmakers.status.paused",
  },
];
